type NameFields = {
  firstName?: string | null;
  infix?: string | null;
  lastName?: string | null;
};

export function getWorkerFullName(nameFields: NameFields): string {
  const { firstName, infix, lastName } = nameFields;
  const infixValue = infix ? `${infix} ` : '';
  return `${firstName ?? ''} ${infixValue}${lastName ?? ''}`;
}
